import { useParams } from "react-router-dom";
import DynamicTabs from "../../../components/dynamicTabs";
import { useFeature } from "../../../hooks/featureContext";
import { t } from "i18next";

function DetailsTab() {
  const { assetSlug } = useParams();
  const { hasFeatureBySlug } = useFeature();

  const hasEventsFeature = hasFeatureBySlug("events");
  const hasTotalizersFeature =
    hasFeatureBySlug("totalizers_valve_opening") ||
    hasFeatureBySlug("totalizers_pressure_alarms") ||
    hasFeatureBySlug("totalizers_unloading") ||
    hasFeatureBySlug("totalizers_loading");
  const hasDinamometricCard = hasFeatureBySlug("dynamometer_cards");

  const tabs = [
    {
      name: t("Detalhes Gerais"),
      href: `/detalhes/${assetSlug}`,
    },
    ...(hasEventsFeature
      ? [
          {
            name: t("Eventos"),
            href: `/detalhes/${assetSlug}/eventos`,
          },
        ]
      : []),
    ...(hasTotalizersFeature
      ? [
          {
            name: t("Totalizadores"),
            href: `/detalhes/${assetSlug}/totalizadores`,
          },
        ]
      : []),
    ...(hasDinamometricCard
      ? [
          {
            name: t("Histórico de carta"),
            href: `/detalhes/${assetSlug}/historico-carta`,
          },
        ]
      : []),
  ];

  if (tabs.length <= 1) return null;

  return (
    <div className="w-100">
      <DynamicTabs tabs={tabs} />
    </div>
  );
}

export default DetailsTab;
